<template>
	<div class="page">
		<Tip :tip="tip" />
		<div class="screen_div">
			<el-date-picker class="picker" v-model="screen.created_time" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="创建时间范围" />
			<el-select class="select" v-model="screen.consumer_id" clearable placeholder="客户名称" @visible-change='selectConsumer'>
				<el-option v-for="item in consumerList" :key="item.consumer_id" :label="item.consumer_name" :value="item.consumer_id" />
			</el-select>
			<el-select class="select" v-model="screen.created_by" clearable placeholder="创建人" @visible-change='selectAdmin'>
				<el-option :key="0" label="全部" :value="0" />
				<el-option v-for="item in adminList" :key="item.admin_id" :label="item.nick_name" :value="item.admin_id" />
			</el-select>
			<el-select class="select" v-model="screen.state" clearable placeholder="状态">
                <el-option :key="0" label="全部" :value="0" />
                <el-option :key="1" label="正常" :value="1" />
                <el-option :key="2" label="禁用" :value="2" />
			</el-select>
			<el-button class="screen_btn" @click="getProcurementList">筛选</el-button>
			<el-button class="screen_btn" type="primary" @click="open(-1)">+添加单据</el-button>
		</div>
		<div class="from_div">
			<el-table class="table_div" v-loading="loading"
				:data="tableData"
				:header-cell-style="tabStyle">
				<el-table-column label="编号" width="80" align="center" prop="procurement_id"/>
				<el-table-column label="客户单位" align="center">
					<template slot-scope="scope">
						<span>{{scope.row.consumer.consumer_company}}</span>
					</template>
				</el-table-column>
				<el-table-column label="商品数" align="center" prop="procurement_quatity"/>
				<el-table-column label="业务总额" align="center" prop="procurement_amount"/>
				<el-table-column label="创建人" align="center">
					<template slot-scope="scope">
						<div class="col">
							<span>{{scope.row.created_admin.group_name}}-{{scope.row.created_admin.nick_name}}</span>
							<span>{{scope.row.created_time}}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="状态" width="200" align="center" prop="state_text"/>
				<el-table-column label="操作" width="250">
					<template slot-scope="scope">
						<el-button class="item_btn" size="mini" type="primary"
							@click="open(scope.row.procurement_id)">查看</el-button>
						<el-button class="item_btn" size="mini" type="success">提审</el-button>
						<el-button class="item_btn" size="mini" type="danger"
							@click="del(scope.row.procurement_id)">删除</el-button>
						<el-button class="item_btn" size="mini" type="info">打印</el-button>
						<el-button class="item_btn" size="mini" type="warning">付款</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!--弹出层-->
		<Popup :name="name" :show="show" @close='close' :type="procurement_id" :from="4" />
		<div class="foot_div">
			<!--分页按钮-->
			<el-pagination class="pagination" background layout="prev, pager, next,jumper, ->, total" :total="total"
				@current-change="handleCurrentChange" :currentPage="screen.page" :pageSize="screen.limit">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
	import Popup from "../../../components/Popup/Popup.vue"
	import {
		procurementLists,
		procurementDel,
        consumerLists,
        adminLists
	} from "../../../request/apis.js"
	export default {
		components: {
			Tip,
			Popup
		},
		data() {
			return {
				tip: '制订商品的采购计划单。',
				consumerList: [], //客户列表
				adminList: [], //创建人列表
				auditList: [], //状态列表
				procurement_id: -1, //商机id
				screen: {
					consumer_id: '', //客户id
					created_by: '', //创建人id
                    state: '', //状态
					audit: '', //审核状态
					created_time: '', //时间范围
					page: 1, //当前页 刷新后默认显示第一页
					limit: 10, //每一页显示的数据量 此处每页显示10条数据
				},
                loading: false,
				tableData: [],
				total: 0, //总条数
				name: '',
				show: false
			}
		},
		computed: {
			tabStyle() {
				return {
					background: '#f5f5f5',
					color: '#333'
				}
			}
		},
		mounted() {
			this.getProcurementList();
		},
		methods: {

			//获取采购列表
			getProcurementList() {
                this.loading = true;
				procurementLists({
					...this.screen
				}, 4).then(res => {
                    this.loading = false;
					if (res.code == 0) {
						this.total = res.count;
						this.tableData = res.data;
					}else{
                        return this.$message.error(res.msg);
                    }
				}).catch(err => {})
			},

			//点击按钮切换页面
			handleCurrentChange(page) {
				this.screen.page = page; //每次点击分页按钮，当前页发生变化
				this.getProcurementList();
			},
			
			//采购删除
			del(procurement_id) {
				procurementDel({
					procurement_id
				}, 4).then(res => {
					if (res.code == 0) {
						this.tableData = [];
						this.handleCurrentChange(this.screen.page);
					}
				}).catch(err => {})
			},

            async selectAdmin(query){
                if (!query) {
                    return false;
                }
                const res = await adminLists()
                if (res.code) {
                    return this.$message.error(res.msg)
                }
                this.adminList = res.data;
            },

            async selectConsumer(query){
                if (!query) {
                    return false;
                }
                const res = await consumerLists()
                if (res.code) {
                    return this.$message.error(res.msg)
                }
                this.consumerList = res.data;
            },

			open(procurement_id) {
				this.procurement_id = procurement_id;
				this.name = 'AddDocumentDetail';
				this.show = true
			},

			close(type) {
				if (type == 0) {
					this.handleCurrentChange(this.screen.page);
				}
				this.show = false
			}
		}
	}
</script>

<style scoped>
	.page {
		margin-bottom: 66px;
		padding: 20px 20px 0 20px;
		min-height: -webkit-fill-available;
	}

	.screen_div {
		display: flex;
		flex-direction: row;
		width: 100%;
		height: auto;
		margin-top: 20px;
	}

	.col {
		display: flex;
		flex-direction: column;
	}

	.select {
		width: 128px;
		margin-left: 13px;
	}

	.screen_btn {
		margin-left: 13px;
	}

	.el-button--mini {
		margin-right: 10px;
	}

	.item_btn {
		margin: 0 5px 0 0;
	}

	/*伪类样式*/
	.item_btn:nth-child(4) {
		margin-top: 5px;
	}

	.from_div {
		width: 100%;
		height: 620px;
		max-height: 100%;
		overflow: scroll;
		margin-top: 20px;
	}

	.table_div {
		width: 100%;
	}

	.table_div::before {
		height: 0;
	}

	.foot_div {
		position: absolute;
		display: flex;
		flex-direction: row-reverse;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		margin-left: 66px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
		z-index: 9;
	}

	.pagination {
		display: flex;
		padding: 20px 30px 20px 30px
	}

	.el-dropdown-link {
		padding: 15px 5px;
		cursor: pointer;
		color: #fff;
	}

	.dropdown-menu {
		margin-bottom: 25px !important;
	}
</style>